import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { LoginService } from './login.service';
import { LoginIssuerStore } from './login-issuer.store';

@Injectable()
export class Auth0LoginService extends LoginService {
  auth0 = inject(AuthService);
  private readonly issuerStore = inject(LoginIssuerStore);

  loginWithRedirect(): void {
    this.issuerStore.set('auth0');
    this.auth0.loginWithRedirect();
  }
}
